import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.IFA_LIST.PATH;
const DEFAULT_PAGE_SIZE=500;
@Injectable()
export class IFAListService extends AbstractService<any> {
  constructor(
    http: HttpClient,

    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public addTag(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}addtag`,
      body: data,
    });
  }

  public deleteTag(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}deletetag`,
      body: data,
    });
  }

  public getIFAList(data: any, pageNumber:number=1, pageSize:number=DEFAULT_PAGE_SIZE, query:string): Observable<any> {
    let url = `${this.url}device?pagenum=${pageNumber}&numrecords=${pageSize}`;
    if(query){
      url = `${this.url}device?srch=${query}&pagenum=${pageNumber}&numrecords=${pageSize}`;
    }
    return this.request({
      method: HTTP_METHODS.POST,
      url: url,
      body: data,
    });
  }

  public addUserInTag(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}adduserintag`,
      body: data,
    });
  }

  public deleteUserInTag(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}deleteuserintag`,
      body: data,
    });
  }

  public blockIFA(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}blockifauser`,
      body: data,
    });
  }

  public blockDevice(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}blockdevice`,
      body: data,
    });
  }
}
